import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "col-6-small is-hidden-above-medium is-hidden-below-small"
}

import { ref, computed } from 'vue'
import { useGettext } from 'vue3-gettext'
import { useStore } from 'vuex'
import BalancePanel from '@/components/BalancePanel.vue'
import PayoutMethods from '@/components/PayoutMethods.vue'
import VerificationPanel from '@/components/VerificationPanel.vue'
import TransactionsHistory from '@/components/TransactionsHistory.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PayoutsPage',
  setup(__props) {

const { $gettext } = useGettext()
const store = useStore()
const historyRef = ref<InstanceType<typeof TransactionsHistory> | null>(null)

const isPayoutPanelShown = computed(
  () => !store.state.hasSubscriptionError
    && !store.getters.isSuspended
    && store.getters.isKycVerified
    && store.getters.isUserEmailVerified
    && (!store.getters.isSubscriptionMissing || !store.state.hasActiveReleases),
)

const isVerificationPanelShown = computed(
  () => store.state.hasSubscriptionError
    || store.getters.isSubscriptionMissing
    || !store.getters.isUserEmailVerified
    || store.getters.isSuspended
    || !store.getters.isKycVerified
    || store.getters.unverifiedActivePayoutMethods.length > 0,
)

const refreshHistory = () => {
  historyRef.value?.refreshHistory()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h1", null, _toDisplayString(_unref($gettext)('Payouts')), 1),
    (isVerificationPanelShown.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(VerificationPanel, { class: "col-12 col-8-medium" })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BalancePanel, {
        class: "col-12 col-8-medium",
        onPayoutRequestSent: refreshHistory
      }),
      (isPayoutPanelShown.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      (isPayoutPanelShown.value)
        ? (_openBlock(), _createBlock(PayoutMethods, {
            key: 1,
            class: "col-12 col-6-small col-4-medium"
          }))
        : _createCommentVNode("", true)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
    _createVNode(TransactionsHistory, {
      ref_key: "historyRef",
      ref: historyRef
    }, null, 512)
  ]))
}
}

})